function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect, useRef, useState, useCallback } from 'react';

var useWatermark = function useWatermark(WMProps) {
  var ref = useRef(null);
  var srcRef = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(WMProps),
      _useState4 = _slicedToArray(_useState3, 2),
      config = _useState4[0],
      setConfig = _useState4[1];

  var content = config.content,
      _config$width = config.width,
      width = _config$width === void 0 ? 100 : _config$width,
      _config$height = config.height,
      height = _config$height === void 0 ? 100 : _config$height,
      _config$xOffset = config.xOffset,
      xOffset = _config$xOffset === void 0 ? 0 : _config$xOffset,
      _config$yOffset = config.yOffset,
      yOffset = _config$yOffset === void 0 ? 0 : _config$yOffset,
      _config$textAlign = config.textAlign,
      textAlign = _config$textAlign === void 0 ? 'center' : _config$textAlign,
      _config$verticalAlign = config.verticalAlign,
      verticalAlign = _config$verticalAlign === void 0 ? 'middle' : _config$verticalAlign,
      _config$fontSize = config.fontSize,
      fontSize = _config$fontSize === void 0 ? '16px' : _config$fontSize,
      _config$fontFamily = config.fontFamily,
      fontFamily = _config$fontFamily === void 0 ? 'Microsoft Yahei' : _config$fontFamily,
      _config$color = config.color,
      color = _config$color === void 0 ? 'rgba(255, 0, 0, 0.9)' : _config$color,
      _config$backgroundRep = config.backgroundRepeat,
      backgroundRepeat = _config$backgroundRep === void 0 ? 'repeat' : _config$backgroundRep,
      _config$rotate = config.rotate,
      rotate = _config$rotate === void 0 ? 20 : _config$rotate,
      _config$zIndex = config.zIndex,
      zIndex = _config$zIndex === void 0 ? 1000000 : _config$zIndex;
  var updateConfig = useCallback(function (newWMProps) {
    setConfig(_objectSpread(_objectSpread({}, config), newWMProps));
  }, [config]);

  var generateCanvasData = function generateCanvasData() {
    var canvas = document.createElement('canvas');
    canvas.setAttribute('width', "".concat(width, "px"));
    canvas.setAttribute('height', "".concat(height, "px"));
    var ctx = canvas.getContext('2d');
    ctx.textAlign = textAlign;
    ctx.textBaseline = verticalAlign;
    ctx.font = "".concat(fontSize, " ").concat(fontFamily);
    ctx.fillStyle = color;
    ctx.rotate(-(Math.PI / 180) * rotate);
    ctx.fillText(content, width / 2 + xOffset, height / 2 + yOffset);
    var link = canvas.toDataURL();
    return link;
  };

  var setStyles = function setStyles(link, curr) {
    curr.setAttribute('style', "width:max-content;height:max-content;z-index:".concat(zIndex, ";background-repeat:").concat(backgroundRepeat, ";background-image:url(\"").concat(link, "\");"));
    curr.setAttribute('id', '');
    curr.setAttribute('class', '');
  };

  var getWMImage = _async(function (imageUrl) {
    if (imageUrl == null) {
      return '';
    }

    var image = new Image();
    image.src = imageUrl;
    image.setAttribute('crossOrigin', 'Anonymous');
    var canvas = document.createElement('canvas');
    return _await(image.decode(), function () {
      canvas.setAttribute('width', "".concat(image.width, "px"));
      canvas.setAttribute('height', "".concat(image.height, "px"));
      var ctx = canvas.getContext('2d');
      ctx.textAlign = textAlign;
      ctx.textBaseline = verticalAlign;
      ctx.font = "".concat(fontSize, " ").concat(fontFamily);
      ctx.drawImage(image, 0, 0, image.width, image.height);
      ctx.save();
      ctx.rotate(-(Math.PI / 180) * rotate);
      ctx.fillStyle = color;
      ctx.fillText(content, width / 2 + xOffset, height / 2 + yOffset);
      var _config$columns = config.columns,
          columns = _config$columns === void 0 ? image.width / width : _config$columns,
          _config$rows = config.rows,
          rows = _config$rows === void 0 ? image.height / height : _config$rows;

      if (backgroundRepeat === 'repeat') {
        for (var i = 0; i <= columns; ++i) {
          for (var j = 0; j <= rows; ++j) {
            if (i === 0 && j === 0) return;
            ctx.fillText(content, width / 2 + xOffset + width * i, height / 2 + yOffset + height * j);
          }
        }
      } else if (backgroundRepeat === 'repeat-x') {
        for (var _i2 = 1; _i2 <= columns; ++_i2) {
          ctx.fillText(content, width / 2 + width * _i2 + xOffset, height / 2 + yOffset);
        }
      } else if (backgroundRepeat === 'repeat-y') {
        for (var _i3 = 1; _i3 <= rows; ++_i3) {
          ctx.fillText(content, width / 2 + xOffset, height / 2 + height * _i3 + yOffset);
        }
      }

      ctx.restore();
      return canvas.toDataURL();
    });
  });

  useEffect(function () {
    var curr = ref.current;
    if (curr == null) return;
    var mutationObserver;

    if (curr instanceof HTMLImageElement) {
      if (srcRef.current == undefined) {
        srcRef.current = curr.src;
      }

      setLoading(true);
      getWMImage(srcRef.current).then(function (link) {
        setLoading(false);
        curr.setAttribute('src', link);
        mutationObserver = new MutationObserver(function () {
          mutationObserver.disconnect();
          curr.setAttribute('src', link);
          mutationObserver.observe(curr, {
            attributeFilter: ['src']
          });
        });
        mutationObserver.observe(curr, {
          attributeFilter: ['src']
        });
      });
    } else {
      var link = generateCanvasData();
      mutationObserver = new MutationObserver(function () {
        mutationObserver.disconnect();
        setStyles(link, curr);
        mutationObserver.observe(curr, {
          attributes: true
        });
      });
      setStyles(link, curr);
      mutationObserver.observe(curr, {
        attributes: true
      });
    }

    return function () {
      mutationObserver.disconnect();
    };
  }, [config]);
  return {
    ref: ref,
    updateConfig: updateConfig,
    loading: loading
  };
};

export default useWatermark;